import { cutToast } from 'utility/toast';
import React from 'react';
import { DepartmentGroupRow } from '..';

import { useMutation } from '@apollo/client';
import {
  DepartmentGroupDelete,
  DepartmentGroupDeleteVariables,
} from './__generated__/DepartmentGroupDelete';
import { EntityDeleteInput } from 'common/types/globalTypes';
import { ActionMessageModal } from 'common/components/ActionMessageModal';
import { EntityAction, EntityType } from 'common/types/utility';
import DEPARTMENT_GROUP_DEPARTMENT from './DepartmentGroupDelete.graphql';

interface DeleteDepartmentGroupProps {
  selectedRows: DepartmentGroupRow[];
}

export const DeleteDepartmentGroup: React.FC<DeleteDepartmentGroupProps> = ({
  selectedRows,
}) => {
  const [departmentGroupDelete] = useMutation<
    DepartmentGroupDelete,
    DepartmentGroupDeleteVariables
  >(DEPARTMENT_GROUP_DEPARTMENT, { errorPolicy: 'all' });

  const _onConfirm = async () => {
    const deletableRows: DepartmentGroupRow[] = selectedRows.filter(
      (item) => item._isDeletable
    );
    const entityDelete: EntityDeleteInput[] = deletableRows.map((item) => {
      return { id: item.id, rowTimestamp: item._rowTimestamp! };
    });
    const { errors } = await departmentGroupDelete({
      variables: {
        input: {
          entityDelete,
        },
      },
      update(cache) {
        deletableRows.forEach((item) => {
          const identity = cache.identify({
            ...item,
          });
          cache.evict({ id: identity });
          cache.gc();
        });
      },
    });
    if (errors?.length) cutToast.error(errors[0].message);
    else {
      cutToast.success('Record deleted successfully.');
    }
  };

  return (
    <ActionMessageModal
      entityType={EntityType.DepartmentGroup}
      action={EntityAction.Remove}
      disabled={!selectedRows.some((selected) => selected._isDeletable)}
      visible={!!selectedRows.length}
      multiple={{
        validCount: selectedRows.filter((selected) => selected._isDeletable)
          .length,
        invalidNames: selectedRows
          .filter((selected) => !selected._isDeletable)
          .map((selected) => selected.name || ''),
      }}
      onConfirm={_onConfirm}
    />
  );
};
